require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = 418
// module chunks = 0